var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-seal",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('img',{staticClass:"seal-img",attrs:{"src":_vm.sealSrc,"alt":"安享花金融服务有限公司合同专用章","draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }